import { NgModule } from '@angular/core';
import { LinkingMisonetComponent } from './linking-misonet/linking-misonet.component';
import { SharedProviderModule } from '../shared/shared.module';
import { NgbTypeaheadModule, NgbPaginationModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { LinkingCrudService } from './linking.service';
import { MappingService } from './mapping.service';
import { OrderByModule } from '../components/order-by/order-by.module';
import { LinkingVivoComponent } from './linking-vivo/linking-vivo.component';
import { VivoModule } from '../vivo/vivo.module';
import { LinkingValmetComponent } from './linking-valmet/linking-valmet.component';



@NgModule({
  imports: [
    SharedProviderModule,
    NgbTypeaheadModule,
    NgbPaginationModule,
    NgbTooltipModule,
    OrderByModule,
    VivoModule
  ],
  declarations: [LinkingMisonetComponent, LinkingVivoComponent, LinkingValmetComponent],
  exports: [LinkingMisonetComponent, LinkingVivoComponent, LinkingValmetComponent],
  providers: [LinkingCrudService, MappingService]
})
export class LinkingModule { }
